import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box } from '@mui/material';

import { FileCloseWrapper } from './styled-components';

const FileItem = ({ itemKey, removeItem, setFieldValue }: { setFieldValue: (name: string, value: FileList) => void,itemKey: number, removeItem: (key:number, setFieldValue: (name: string, value: FileList) => void) => void, }) => {
  return (
    <button style={{ border: '0px', backgroundColor: 'transparent', cursor: 'pointer' }} onClick={() => { removeItem(itemKey, setFieldValue); }}>
      <Box>
        <FileCloseWrapper>
          <CloseRoundedIcon sx={{ color: '#FE2525', fontSize: '16px' }}/>
        </FileCloseWrapper>
      </Box>
    </button>
  );
};

export default FileItem;